<div class="wrapper-preferences">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Referral" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- hide old menu layout -->
  <div class="section-main">
    <div class="row my-2">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
        <div class="card">
          <h4 class="card-body-title font-weight-bold">
            {{ "Share your referral link" | translate }}
          </h4>
          <p class="card-body-subtitle mt-2">
            {{ "Share your unique referral link with friends and earn extra bonuses when they successfully place an order using your link." | translate }}
          </p>
          <div class="mt-4">
            <div *ngFor="let urlLink of programLinks | keyvalue" class="py-2">
              <span class="referral-link-name">{{ "Company Referral Program" | translate }} ({{ urlLink.key.charAt(0).toUpperCase() + urlLink.key.slice(1) }} {{ 'Link' | translate}}) :</span>
              <div class="referral-body my-2">
                <div class="referral-url">
                  <p class="border-gray">
                    {{ urlLink.value }}
                  </p>
                </div>
                <div class="flex gap-3">
                  <button
                    [openDelay]="300"
                    [closeDelay]="500"
                    ngbTooltip="Copy link"
                    class="btn btn-blue-referral w-100"
                    (click)="copyUrl(urlLink.value)"
                  >{{ "Copy" | translate }}</button>
                  <button
                    [openDelay]="300"
                    [closeDelay]="500"
                    ngbTooltip="Share"
                    class="btn btn-grey-referral inline-flex w-100"
                    (click)="shareUrl(urlLink.value)"
                  >
                    <span class="share-icon"></span>
                    <p class="share-text">{{ "Share" | translate }}</p>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
